import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Title, Subtitle } from 'app/src/styles';
import { useNavigate, useParams } from 'app/src/utils/routing';

import { PROVIDER, UPDATE_PROVIDER } from './queries';
import { FIELDS } from './new';

const Provider = () => {
  const { id } = useParams();
  const [formStatus, setFormStatus] = useState();
  const navigate = useNavigate();

  const { control, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const { data } = useQuery(PROVIDER, { variables: { id } });

  useEffect(() => {
    if (data) {
      reset(defaultValues({ fields: FIELDS, resource: data.provider }));
    }
  }, [data]);

  const [updateProvider] = useMutation(UPDATE_PROVIDER, {
    onCompleted: () => navigate('/providers'),
  });

  const onSubmit = input => {
    setFormStatus('submitting');
    updateProvider({
      variables: { input: { id, ...prepareInput(input, FIELDS) } }
    });
  };

  const fields = { ...FIELDS };

  return (
    <View>
      <Title>{data?.provider.name}</Title>

      <Subtitle>Client: {data?.provider.client.name}</Subtitle>

      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
      )}
    </View>
  );
};

export default Provider;
